export default {
  apiKey: 'AIzaSyBoU6SwrClRfj_3EbDqLoFSA-WIybHpa7Y',
  authDomain: 'veat-dashboard-auth.firebaseapp.com',
  databaseURL: 'https://veat-dashboard-auth.firebaseio.com',
  projectId: 'veat-dashboard-auth',
  storageBucket: 'veat-dashboard-auth.appspot.com',
  messagingSenderId: '739289141836',
  appId: '1:739289141836:web:56b666486a2026ebafdae9',
}
